import Form from './DocumentsForm'
import Help from './DocumentsHelp'
import isEmpty from './DocumentsIsEmpty'
import Section from './DocumentsSection'
import Thumbnail from './DocumentsThumbnail'

export default { Form, Help, isEmpty, Section, Thumbnail }
